import React from "react";
import { Box, Typography } from "@mui/material";
import { SxProps } from "@mui/system";
import { COLORS } from "components/v3/Theme/colors";

type DashboardCtaCardProps = {
  icon?: string;
  id?: string;
  header: React.ReactNode | string;
  subheader: React.ReactNode | string;
  link: React.HTMLProps<HTMLAnchorElement> & {
    onClick: () => void;
    overrideClick?: boolean;
    text: string;
    url: string;
  };
  sx?: SxProps;
};

const DashboardCtaCard: React.FC<DashboardCtaCardProps> = ({
  header,
  icon,
  id,
  link,
  sx,
  subheader
}) => {
  const hasIcon = !!icon;

  return (
    <Box
      component="a"
      href={link.url}
      id={id}
      onClick={(event) => {
        if (link.overrideClick) {
          event.preventDefault();
        }

        link.onClick();
      }}
      sx={{
        alignItems: "center",
        background: COLORS.ACCENT1_LIGHTEST,
        borderRadius: 2,
        boxSizing: "border-box",
        display: "flex",
        flexBasis: "100%",
        gap: 2,
        paddingX: 3,
        paddingY: 4,
        textDecoration: "none",
        ...sx
      }}
      {...(link.target ? { target: link.target } : {})}
    >
      {hasIcon && (
        <Box
          component="img"
          sx={{
            height: 80,
            width: 80
          }}
          src={icon}
        />
      )}
      <Box sx={{ display: "flex", flexDirection: "column", gap: "7px" }}>
        <Typography variant="body_strong_black">{header}</Typography>
        <Typography variant="body_xs_black">{subheader}</Typography>
        <Typography
          sx={{
            textDecoration: "underline"
          }}
          variant="body_strong_xs_dark_gray"
        >
          {link.text}
        </Typography>
      </Box>
    </Box>
  );
};

export default DashboardCtaCard;
